import { YieldFetcher } from '../../types'

/**
 * Valantis stHYPE / wstHYPE — intrinsic APR from Valantis's own
 * analytics endpoint (the authoritative source behind
 * app.valantis.xyz/staking). The endpoint returns the APR as a bare
 * numeric string (e.g. `"2.7"` = 2.7%).
 *
 * wstHYPE wraps the same balance state as stHYPE, so the single stHYPE
 * APR applies to both. Preferred over the hyperlend `nativeApy` proxy
 * (which mirrors this number but has gone stale/null in the past).
 */
const VALANTIS_STHYPE_APR_URL =
  'https://analytics-v3.valantis-analytics.xyz/sthype/apr'

/** Shared key — matches the wstHYPE registry entry's `yieldKey`. */
const WSTHYPE_KEY = 'Staked HYPE Shares::WSTHYPE'

export const valantisStHypeFetcher: YieldFetcher = {
  label: 'VALANTIS_STHYPE',
  fetch: async () => {
    const text = await fetch(VALANTIS_STHYPE_APR_URL).then((r) => r.text())
    const apr = Number(text.trim())
    if (!Number.isFinite(apr)) {
      throw new Error(`Valantis stHYPE APR: non-numeric response "${text}"`)
    }
    return { [WSTHYPE_KEY]: apr }
  },
}
